import React, { useState } from 'react';

import CloseIcon from '../../../../assets/icons/common/CloseIcon';

import styles from './styles.module.scss';

const VerizonBanner = () => {
  const localStorageKey = 'verizonBannerClosed';
  const [showBanner, setShowBanner] = useState(
    !isBannerClosed(localStorageKey),
  );

  const closeBanner = () => {
    setShowBanner(false);
    localStorage.setItem(localStorageKey, true);
  };

  if (!showBanner) return null;
  return (
    <div className={styles.verizonBanner}>
      <h2>Coming Soon!</h2>
      <p>
        Dashboard access for Titan Pro and Edge 5G routers is on the way. <br />
        For now, contact Support if you need help with your plan or device.
      </p>
      <button onClick={closeBanner} className={styles.closeCircle}>
        <CloseIcon />
      </button>
    </div>
  );
};

function isBannerClosed(localStorageKey) {
  return localStorage.getItem(localStorageKey) === 'true';
}

export default VerizonBanner;
